module.exports = __webpack_public_path__ + "blackrocks.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackrocks.png
// module id = 865
// module chunks = 0